import moment from "moment";
import { FormatNumber2 } from "../../../utility/functions/formatNumber";

export const SummaryColumns = (width, openingBalDetails) => {
  const columns = [
    {
      field: "DATE",
      accessor: "DATE",
      type: "string",
      width: width < 768 ? 100 : width < 1400 ? 120 : 120,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center  px-1 `}>
            {param.value ? moment(param.value).format("YYYY-MM-DD") : ""}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          {" "}
          Date
        </div>
      ),
    },
    {
      field: "VOUCHER_NO",
      accessor: "VOUCHER_NO",
      type: "string",
      width: 100,
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center  px-1 `}>
            {param.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          {" "}
          Voucher No.
        </div>
      ),
    },

    {
      field: "DOC_NO",
      accessor: "DOC_NO",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 100,
      align: "left",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center   px-1`}>
            {param.value}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Doc No.
        </div>
      ),
    },
    {
      field: "TRASACTION_TYPE",
      accessor: "TRASACTION_TYPE",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 100,
      align: "left",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center   px-1`}>
            {param.value}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Type
        </div>
      ),
    },
    {
      field: "NARRATION",
      accessor: "NARRATION",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 350,
      align: "left",
      renderCell: (param) => {
        return (
          <div className={` h-full w-full  flex items-center   px-1`}>
            {param.value}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Description
        </div>
      ),
    },
    {
      field: "DEBIT",
      accessor: "DEBIT",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 150,
      align: "right",
      renderCell: (param) => {
        const debit = param.value ? param.value : 0;
        return (
          <div
            className={` h-full w-full  flex items-center  justify-end px-1`}
          >
            {debit !== 0 ? FormatNumber2(debit) : ""}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Debit
        </div>
      ),
    },
    {
      field: "CREDIT",
      accessor: "CREDIT",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 150,
      align: "right",
      renderCell: (param) => {
        const Credit = param.value ? param.value : 0;
        return (
          <div
            className={` h-full w-full  flex items-center  justify-end px-1`}
          >
            {Credit !== 0 ? FormatNumber2(Credit) : ""}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Credit
        </div>
      ),
    },
    {
      field: "BALANCE",
      accessor: "BALANCE",
      type: "number",
      headerClassName: "super-app-theme--header",
      width: 150,
      align: "right",
      renderCell: (param) => {
        return (
          <div
            className={` h-full w-full  flex items-center  justify-end px-1`}
          >
            {param.value
              ? FormatNumber2(param.value.toString().replace("-", ""))
              : ""}{" "}
            {param.value.toString().includes("-") ? "Cr" : "Dr"}
          </div>
        );
      },
      headerAlign: "center",

      renderHeader: (params) => (
        <div className="text-white  text-center" style={{ fontSize: 13 }}>
          Balance
        </div>
      ),
    },
  ];

  return columns;
};
